export const danhMucThuKhac = {
  sections: {
    list: { title: '其他费用目录' },
    detail: { title: '其他费用目录' },
  },
  titles: { add: '新增费用项', edit: '编辑费用项' },
  columns: {
    code: '编码',
    summary: '费用名称',
    note: '说明',
    loaiThuKhac: '费用类型',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    status: '状态',
    onOffAction: '启停',
  },
  filter: {
    searchPlaceholder: '按费用编码、名称搜索...',
    textDetailTitle: '详细筛选',
  },
  filters: {
    hintSection: '提示',
    hintBody: '管理用于发票和退货单的其他费用项。',
    statusAll: '全部',
    loaiThuKhacAll: '全部',
  },
  loaiThuKhac: {
    CO_DINH: '固定金额 (VND)',
    PHAN_TRAM: '百分比 (%)',
    TUY_CHON: '可选',
  },
  status: {
    dangHoatDong: '启用',
    ngungHoatDong: '暂停',
  },
  trangThai: {
    DANG_HOAT_DONG: '启用',
    TAM_NGUNG: '暂停',
  },
  actions: {
    pause: '暂停',
    activate: '启用',
  },
  messages: {
    loadError: '无法加载费用目录。',
    deleteSuccess: '已删除费用项。',
    noData: '暂无费用项。',
    listSummary: '共 {count} 项',
    saveSuccess: '已保存费用项。',
    statusChanged: '状态已更新。',
    selectedCount: '已选 {count} 项',
    deleteSelected: '删除已选 ({count})',
    bulkDeleteConfirm: '确认删除已选 {count} 个费用项？',
    bulkDeleteSuccess: '已删除 {count} 个费用项',
    bulkDeletePartial: '已删除 {ok}/{total}。{failed} 项失败。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '未选择要删除的费用项',
  },
  form: {
    maThuKhac: '费用编码',
    maThuKhacPlaceholder: '留空则自动生成 (TK0001…)',
    maThuKhacHint: '不填则系统自动生成 TK + 4 位数字。',
    tenThuKhac: '费用名称',
    loaiThuKhac: '费用类型',
    giaTri: '金额 (VND)',
    phanTram: '百分比 (%)',
    moTa: '说明',
  },
  validation: {
    tenRequired: '请输入费用名称。',
    giaTriRequired: '固定金额必须为非负数。',
    phanTramRequired: '百分比必须在 0 到 100 之间。',
  },
  placeholders: {
    formTitle: '其他费用目录',
    formBody: '',
  },
  reorder: {
    open: '排序',
    title: '其他费用排序',
    hint: '使用上移/下移调整顺序。此顺序即发票列表中其他费用列的顺序。',
    move: '移动',
    moveUp: '上移',
    moveDown: '下移',
    saved: '已更新其他费用顺序',
    saveFailed: '更新顺序失败',
  },
}
